/* eslint-disable @typescript-eslint/no-explicit-any */
import InitialsBubble from "features/settings/manage-users/components/initials-bubble";
import React from "react";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomTooltip from "shared/components/CustomTooltip";
import Editor from "shared/components/Editor/Editor";
import { CreateActionsDropdown } from "shared/dropdowns/CreateActionsDropdown";
import { IconDispatcher } from "shared/Icons";
import { Button } from "shared/ui-basics";
import styled from "styled-components/macro";
import { Flex } from "../../modals/comment-center.style";
import { createComment, deleteComment, deleteDiscussion, updateComment, updateStatusDiscussion } from "../../reducer/MapActions";
import CommentEditor from "../CommentEditor";
import { setOpenDiscussion } from "features/comments/reducer/commentSlice";
import $ from "jquery";
type DiscussionProps = {
	discussion: any;
	subject: string;
	discussionId: string;
	setDiscussionState?: any;
	innerRef?: React.RefObject<any>;
	hidden?: boolean;
};

const Discussion = ({ discussion, subject, discussionId, setDiscussionState, innerRef, hidden }: DiscussionProps): JSX.Element => {
	const { cjmIdStr, personaIdStr } = getAllMapsParams(useLocation().search);
	const users = useSelector((state: any) => state.settings?.authorizedUsers);
	const currentUserId = useSelector((state) => state?.auth?.userInfo.UserId);

	const [edit, setEdit] = React.useState<number | null>(null);
	const [mention, setMention] = React.useState<any>([]);
	const { t } = useTranslation();
	const isInCommentCenter = hidden;
	const commentCounts = discussion?.comments?.length || 0;
	const isResolved = discussion?.isResolved;
    const [showReply, setShowReply] = React.useState<boolean>(false);

	const onSubmit = (value: string, mentions: any) => {
		createComment({
			discussionId: discussionId,
			description: value,
			mentions: mentions,
			cjmIdStr,
			personaIdStr,
		});
        
	};
	const getActions = (index: number) => {
		const commentOwnerId = discussion?.comments[index]?.ownerId;
		const isOwner = commentOwnerId === currentUserId;
		if (!isOwner) return [];
		return [
			{
						id: "edit",
						handleClick: () => setEdit(index),
						icon: "EDIT",
						text: t("EDIT"),
			},
			{
				id: "delete",
				handleClick: () => {
					if (index === 0) {
						deleteDiscussion({
							discussionId: discussion?.id,
							cjmId: cjmIdStr,
							personaId: personaIdStr,
						});
						if (setDiscussionState) {
							setDiscussionState((prev: any[]) => prev?.filter((id: string) => id !== discussion?.id));
						}
						if (innerRef && innerRef.current?.hide_popover) {
							innerRef.current?.hide_popover();
						}
					} else {
						deleteComment({ commentId: discussion?.comments[index]?.id, discussionId: discussion.id, cjmIdStr, personaIdStr });
					}
				},
				icon: "DELETE",
				text: t(index === 0 ? "DELETE_CONVERSATION" : "DELETE_COMMENT"),
			},
		];
	};
	const update = (values: string) => {
		if (edit === null) return;
		updateComment({
			commentId: discussion?.comments[edit]?.id,
			newDescription: values,
			cjmId: cjmIdStr,
			personaId: personaIdStr,
			discussionId: discussion.id,
			mentions: mention,
		});

		setEdit(null);
		setMention([]);
	};
	const resolveDiscussion = (e: any) => {
		e.stopPropagation();
		updateStatusDiscussion({
			discussionId: discussion?.id,
			isResolved: !discussion.isResolved,
			cjmId: cjmIdStr,
			personaId: personaIdStr,
		});
	};
	const openDiscussion = () => {
		if (isInCommentCenter && isResolved === false && edit === null) {
			const swimlane = $(`#swimlanes_${discussion.swimLaneId}`)[0];
			if (swimlane) {
				swimlane.scrollIntoView({ block: "center", behavior: "smooth", inline: "start" });
			}
			setOpenDiscussion(discussion.id);
		}
	};
	return (
		<DiscussionWrapper onClick={openDiscussion} className={hidden && !isResolved ? "c-pointer" : ""}>
			{discussion?.comments?.slice(0, hidden && !showReply ? 1 : Infinity).map((comment: any, index: number) => {
				const user = users?.find((user: any) => user.id === comment.ownerId);
				const actions = getActions(index) as any;
				const isOwner = comment.ownerId === currentUserId;

				return (
					<CommentWrapper key={comment.id}>
						<Flex justify="space-between" align="center">
							<Flex align="end" gap={4}>
								<InitialsBubble fullName={user?.fullName} size={"xs"} />
								<div>{user?.fullName}</div>
								<LastUpdated>
									<Moment fromNow>{comment.lastModifiedOn}</Moment>
								</LastUpdated>
							</Flex>
							<Flex>
								{index === 0 && isOwner && (
									<CustomTooltip text={t(discussion.isResolved ? "REOPEN" : "RESOLVED_DISCUSSION")}>
										<Button variant="light-dark" size='s' onClick={resolveDiscussion}>
											<IconDispatcher type={discussion.isResolved ? "arrow-rotate-left" : "circle-check"} />
										</Button>
									</CustomTooltip>
								)}

								{discussion.isResolved === false &&
									actions.length > 0 &&
									CreateActionsDropdown({
										actions: actions,
										variant: "light-dark",
										dropdownClasses: "p-1",
										stopPropagation: true,
									})}
							</Flex>
						</Flex>
						{index === 0  && subject !== '' && subject && <Subject>{subject}</Subject>}
						<EditWrapper edit={edit === index ? "true" : "false"}>
						<Editor value={comment.description} onUpdate={update as any} disabled={edit !== index} mentionFunction={setMention}  autoFocus={edit === index}/>
						</EditWrapper>
						{hidden && index === 0&& commentCounts > 1 && (
							<Flex align="center" gap={6} style={{ fontSize: "14px", color: "rgba(59, 130, 246, 1)" }} onClick={(e) => {
                                e.stopPropagation();
                                setShowReply(!showReply);

                            } }>
								<div>{commentCounts - 1}</div>
								<div>{commentCounts - 1 > 1 ? t("REPLIES") : t("REPLY")}</div>
							</Flex>
						)}
					</CommentWrapper>
				);
			})}
			{!hidden && !isResolved && (
				<div className="p-2" key={discussion?.comments.length}>
					<CommentEditor onSubmit={onSubmit} placeholder="REPLY" />
				</div>
			)}
		</DiscussionWrapper>
	);
};

function getAllMapsParams(search: string) {
	const params = new URLSearchParams(search);
	const cjmIdStr = params.get("cjmid");
	const personaIdStr = params.get("personaId");
	return { cjmIdStr, personaIdStr };
}
export default Discussion;
interface DiscussionWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
	onClick?: () => void;
}
const DiscussionWrapper = styled.div<DiscussionWrapperProps>`
	border: 1px solid var(--color-Grey-Border, #d9d9d9);
	border-radius: 4px;
	overflow: hidden;
	width: 100%;
`;
const CommentWrapper = styled.div<{ children?: React.ReactNode }>`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid var(--color-Grey-Border, #d9d9d9);
	overflow: hidden;
	background: var(--slate-50, #f8fafc);

	padding: 16px;
	gap: 16px;
`;
const Subject = styled.div`
	font-size: 14px;
	font-weight: 500;
	padding: 4px 8px;
	border-radius: 4px;
	color: var(--color-Black-Text, #0b0b0b);
	background: var(--slate-200, #e2e8f0);
`;
const LastUpdated = styled.div`
	font-size: 12px;
	color: var(--color-Grey-Text, #6b6b6b);

`;
interface EditWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
	edit?: string;
}
const EditWrapper = styled.div<EditWrapperProps>`
${props => props.edit === 'true' && `border-radius: 4px;padding:4px;background:#ffffff; border: 1px solid #262626;`}
`;